
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  data() {
    return {
      listItemToggled: false,
      filterActive: false,
    }
  },
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
      vxSelectedSortingOption: 'search/getSelectedSortingOption',
    }),
    selectedSortingOption: {
      get() {
        return this.vxSelectedSortingOption
      },
      set(value) {
        this.vxSetIsShowingFilters(false)
        this.vxSetSearchParameters({ sort: value })
        this.vxQuerySearchspring()
      },
    },
  },
  methods: {
    ...mapMutations({
      vxSetSearchParameters: 'search/setSearchParameters',
      vxSetIsShowingFilters: 'search/setIsShowingFilters',
    }),
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
  },
}
